import { get, getOr, flow, orderBy, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getItemForm = get('inventory.components.itemForm');

export const getPackageItems = createSelector(getItemForm, get('packageItems'));

export const getFormPackageItems = createSelector(
  getItemForm,
  flow(
    get('formPackageItems'),
    values,
    orderBy('name', 'asc')
  )
);

export const getIsFetchingPackageItems = flow(
  getItemForm,
  get('fetchingPackageItems')
);

export const getIsFetchedPackageItems = flow(
  getItemForm,
  get('fetchedPackageItems')
);

export const getPackageActiveReservationOrderItemsCount = createSelector(
  getItemForm,
  get('packageActiveReservationOrderItemsCount')
);

export const getIsFetchingPackageActiveReservationOrderItemsCount = createSelector(
  getItemForm,
  get('fetchingPackageActiveReservationOrderItemsCount')
);

export const getIsFetchedPackageActiveReservationOrderItemsCount = createSelector(
  getItemForm,
  get('fetchedPackageActiveReservationOrderItemsCount')
);

export const getPackageItemsToAdd = createSelector(
  getItemForm,
  getOr([], 'packageItemsToAdd')
);
export const getPackageItemsToRemove = createSelector(
  getItemForm,
  getOr([], 'packageItemsToRemove')
);

export const getTagOptions = createSelector(
  getItemForm,
  flow(
    get('tagOptions'),
    orderBy('label', 'asc')
  )
);

export const getIsFetchingTagOptions = flow(
  getItemForm,
  get('fetchingTagOptions')
);

export const getIsFetchedTagOptions = flow(
  getItemForm,
  get('fetchedTagOptions')
);

export const getItemOptions = createSelector(
  getItemForm,
  flow(
    get('itemOptions'),
    orderBy('label', 'asc')
  )
);

export const getIsFetchingItemOptions = flow(
  getItemForm,
  get('fetchingItemOptions')
);

export const getIsFetchedItemOptions = flow(
  getItemForm,
  get('fetchedItemOptions')
);
